import { createSelector } from 'reselect'

import selectGitHubNodesById from './selectGitHubNodesById'

export default createSelector(selectGitHubNodesById, Object.values)
